import React, {useEffect, useState} from 'react';
import {LoadingWrapper} from "../../Components/LoadingWrapper";
import ReactTable from "../../Components/ReactTable";
import {Breadcrumbs} from "../../Components/Breadcrumbs";
import Page from "../../Components/Page";
import SelectDropdown from "../../Components/Dropdowns/SelectDropdown";
import {makeApolloClientCall} from "../../../Api/makeApolloApiCall";
import {makeApiCall} from "../../../Api/makeApiCall";

const GeographyHierarchy = () => {

    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    const [selectedMarketPeriod, setSelectedMarketPeriod] = useState(undefined);
    const [marketPeriodOptions, setMarketPeriodOptions] = useState([]);

    useEffect(() => {
        makeApolloClientCall('{ marketPeriodList }').then((marketPeriodResults) => {
            const options = marketPeriodResults.marketPeriodList.sort().reverse().map(mp => ({label: mp, value: mp}));
            setMarketPeriodOptions(options);
        });
    }, []);

    useEffect(() => {
        if (selectedMarketPeriod === undefined) return;
        setLoading(true);
        const endpointUrl = `${process.env.REACT_APP_EDP_API_BASE_URL}/geographyHierarchy/?period=${selectedMarketPeriod}`;
        makeApiCall(endpointUrl).then((response) => {
            setData(response?.data)
        }).finally(() => {
            setLoading(false);
        });
    }, [selectedMarketPeriod])

    const customColumns = [
        {
            header: 'LEAF',
            id: 'leafHeader',
            sticky: 'left',
            headerStyle: {flex: '2 0 auto'},
            columns: [
                {
                    header: "ID", accessorKey: "leafGeographyId", size: 80,
                    filterFn: (row, columnId, filterValue) => !filterValue || Boolean(`${row.getValue(columnId)}`.includes(filterValue))
                },
                {header: "Description", accessorKey: "leafGeographyDescription", size: 320},
            ]
        },
        {
            header: 'Geography Type',
            id: 'geographyTypeHeader',
            headerStyle: {flex: '2 0 auto'},
            columns: [
                {header: "Group ID", accessorKey: "geographyTypeId", size: 80},
                {header: "Group Description", accessorKey: "geographyTypeDescription", size: 232},
            ]
        },
        {
            header: 'LEVEL 1 GEOGRAPHY',
            id: 'level1Header',
            headerStyle: {flex: '2 0 auto'},
            columns: [
                {header: "Group ID", accessorKey: "level1GeographyGroupId", size: 80},
                {header: "Group Description", accessorKey: "level1GeographyGroupDescription", size: 232},
            ]
        },
        {
            header: 'LEVEL 2 GEOGRAPHY',
            id: 'level2Header',
            headerStyle: {flex: '2 0 auto'},
            columns: [
                {header: "Group ID", accessorKey: "level2GeographyGroupId", size: 80},
                {header: "Group Description", accessorKey: "level2GeographyGroupDescription", size: 232},
            ]
        },
        {
            header: 'LEVEL 3 GEOGRAPHY',
            id: 'level3Header',
            headerStyle: {flex: '2 0 auto'},
            columns: [
                {header: "Group ID", accessorKey: "level3GeographyGroupId", size: 80},
                {header: "Group Description", accessorKey: "level3GeographyGroupDescription", size: 232},
            ]
        },
        {
            header: 'LEVEL 4 GEOGRAPHY',
            id: 'level4Header',
            headerStyle: {flex: '2 0 auto'},
            columns: [
                {
                    header: "ID", accessorKey: "level4GeographyId", size: 80,
                    filterFn: (row, columnId, filterValue) => !filterValue || Boolean(`${row.getValue(columnId)}`.includes(filterValue))
                },
                {header: "Description", accessorKey: "level4GeographyDescription", size: 320},
            ]
        },
        {
            header: '',
            id: 'orderNumberHeader',
            headerStyle: {flex: '1 0 auto'},
            columns: [
                {
                    header: "Order Number", accessorKey: "orderNumber",
                    filterFn: (row, columnId, filterValue) => !filterValue || Boolean(`${row.getValue(columnId)}`.includes(filterValue))
                }
            ]
        }
    ];

    return <Page name={"Geography Hierarchy"} beta={true}
                 breadCrumbs={<Breadcrumbs
                     items={[{label: 'Services'}, {label: 'Geography'}, {label: 'Geography Hierarchy'}]}/>}>
        <div className={"geography-hierarchy-container"} data-testid={"geography-hierarchy-container"}>
            <div className={'geography-hierarchy-options'}>
                <SelectDropdown id={"market_period_dropdown"}
                                dataTestId={"market_period_dropdown"}
                                inputLabel={"Period"}
                                selectValue={selectedMarketPeriod}
                                options={marketPeriodOptions}
                                onChange={(option) => setSelectedMarketPeriod(option.value)}
                />
            </div>
        </div>
        <br/>
        {selectedMarketPeriod &&
            <LoadingWrapper loading={loading}>
                <ReactTable data={data}
                            columns={customColumns}
                            initialState={{pagination: {pageSize: 10}, sorting: [{id: "leafGeographyId", desc: false}]}}
                            filterable={true}
                            hasStickyHeader={true}/>
            </LoadingWrapper>}
    </Page>
};

export default GeographyHierarchy;